import en from './en.json';
import uk from './uk.json';
import pl from './pl.json';
import ru from './ru.json';
import es from './es.json';
import uz from './uz.json';
import hi from './hi.json';
import { createLocale } from '../../utils.js';

const locales = {
  en: createLocale(en, 'workCenters'),
  uk: createLocale(uk, 'workCenters'),
  pl: createLocale(pl, 'workCenters'),
  ru: createLocale(ru, 'workCenters'),
  es: createLocale(es, 'workCenters'),
  uz: createLocale(uz, 'workCenters'),
  hi: createLocale(hi, 'workCenters'),
};

export default locales;
